function docappCartModifier(cart) {
    if (cart) {
        let modifiedCart = cart
        let customPriceTotal = 0
        let bundlePriceTotal = 0

        cart.items.forEach((item, index) => {
            // if this item is a customize product
            if (item.properties['_customPrice']) {
                customPrice = Number(item.properties['_customPrice']) * 100

                // modify item prices - add custom price
                modifiedCart.items[index].original_price = cart.items[index].original_price + customPrice
                modifiedCart.items[index].price = cart.items[index].price + customPrice // deprecated, but is being used by docapp
                modifiedCart.items[index].final_price = cart.items[index].final_price + customPrice

                // modify line prices - add custom price x item quantity
                modifiedCart.items[index].original_line_price = cart.items[index].original_line_price + customPrice * item.quantity
                modifiedCart.items[index].line_price = cart.items[index].line_price + +(customPrice * item.quantity) // deprecated, but is being used by docapp
                modifiedCart.items[index].final_line_price = cart.items[index].final_line_price + +(customPrice * item.quantity)

                customPriceTotal += customPrice * item.quantity

            } else if (item.properties['_bundleId']) {

                let bundleItemDiscount = Number(item.properties['_bundleLineDiscount']) / Number(item.properties['_bundleLineLength'])
                let bundleLineDiscount = item.quantity * bundleItemDiscount

                // modify item prices
                modifiedCart.items[index].original_price = cart.items[index].original_price - bundleItemDiscount
                // modifiedCart.items[index].price = cart.items[index].price - bundleItemDiscount // deprecated, but is being used by docapp
                modifiedCart.items[index].final_price = cart.items[index].final_price - bundleItemDiscount

                // modify line prices
                modifiedCart.items[index].original_line_price = cart.items[index].original_line_price - bundleLineDiscount
                modifiedCart.items[index].line_price = cart.items[index].line_price - bundleLineDiscount // deprecated, but is being used by docapp
                modifiedCart.items[index].final_line_price = cart.items[index].final_line_price - bundleLineDiscount

                bundlePriceTotal += bundleLineDiscount
                // console.log('bundlePriceTotal', bundlePriceTotal)
            }
        })

        // modify cart prices
        modifiedCart['original_total_price'] = cart.original_total_price + customPriceTotal - bundlePriceTotal
        modifiedCart['items_subtotal_price'] = cart.items_subtotal_price + customPriceTotal - bundlePriceTotal
        modifiedCart['total_price'] = cart.total_price + customPriceTotal - bundlePriceTotal

        return modifiedCart
    }
}

let codes = []

// update the list of codes whenever the app detects a discount code change
document.body.addEventListener('docapp-discount-applied', (e) => {
    codes = []
    e.discounts.forEach((disc) => {
        let code_obj = {}
        code_obj['code'] = disc.title
        code_obj['amount'] = disc.amount
        code_obj['discClass'] = disc.discountClass
        codes.push(code_obj)
    })
})

// custom checkout to use with the Discount on Cart app
const customCheckoutDocApp = async (event) => {
    event.preventDefault()
    const atcBtn = event.target
    const btnText = event.target.innerHTML
    event.target.classList.add('ajax-loading')
    event.target.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>'

    try {
        // fetch the current cart
        const cart = await fetch(`/cart.json`)
        const data = await cart.json()

        // get the app discounted cart
        let modifiedItems
        if (window['discountOnCartProApp'] && window['discountOnCartProApp'].getDiscountedCart()) {
            modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
            integrateDiscount(modifiedItems, data, atcBtn, btnText)
        } else {
            setTimeout(async () => {
                if (window['discountOnCartProApp'] && window['discountOnCartProApp'].getDiscountedCart()) {
                    modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
                    integrateDiscount(modifiedItems, data, atcBtn, btnText)
                } else {
                    setTimeout(async () => {
                        modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
                        integrateDiscount(modifiedItems, data, atcBtn, btnText)
                    }, 2000)
                }
            }, 1000)
        }
    } catch (error) {
        alert('cart: ' + error.message)
    }
}

const integrateDiscount = (modifiedItems, data, atcBtn, btnText) => {
    // calculate the discount allocations
    modifiedItems.forEach((item, index) => {
        // update the modifiedItems key to current cart item key
        item.key = data.items[index].key
        
        // check if the item is a custom item, if yes split the discounts
        if( data.items[index].properties['_customParent']) {
            // update the _customParent to item key
            data.items[index].properties['_customParent'] = data.items[index].key

            // get the line price for parent and addon
            const parentPrice = data.items[index].original_line_price

            // calculate and assign the discount allocations proportionately
            item['parent_discount'] = Math.round((parentPrice / item.original_line_price) * item.total_discount)
            item['addon_discount'] = item.total_discount - item['parent_discount']
            item['combined_discount'] = item['parent_discount']
        }

        // check if the item is part of a bundle, if yes calculate the combined bundle discount + order discount
        else if( data.items[index].properties['_bundleId']) {
            let bundleDiscount = item.price * item.quantity - item.original_line_price 
            item['combined_discount'] = item.total_discount + bundleDiscount
        }

        else {
            item['combined_discount'] = item.total_discount
        }
    })

    // build the payload object
    let cartData = {
        action: 'bundle-draft-order',
        items: JSON.stringify(data.items),
        codes: JSON.stringify(codes),
        app_items: JSON.stringify(modifiedItems),
    }

    // pass the payload to the custom checkout proxy
    $.ajax({
        type: 'POST',
        url: '/apps/integration',
        data: cartData,
        dataType: 'json',
        error: function (error) {
            e = JSON.parse(error.responseText)
            desc = e.description
            alert(desc)
            atcBtn.classList.remove('ajax-loading')
            atcBtn.innerHTML = btnText
        },
        success: function (data) {
            if (data.api === true) {
                if (data.url) {
                    window.location.href = data.url
                } else {
                    alert('Something went wrong. Please contact our customer support.')
                }
            } else {
                alert(data.msg)
            }
            atcBtn.classList.remove('ajax-loading')
            atcBtn.innerHTML = btnText
        },
    })
}
// custom checkout original
const customCheckout = async (event) => {
    event.preventDefault()
    const btnText = event.target.innerHTML
    event.target.classList.add('ajax-loading')
    event.target.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>'

    fetch(`/cart.js`)
        .then((response) => response.json())
        .then(function (data) {
            const cartData = {
                action: 'draft-order',
                items: JSON.stringify(data.items),
            }

            $.ajax({
                type: 'POST',
                url: '/apps/integration',
                data: cartData,
                dataType: 'json',
                error: function (error) {
                    e = JSON.parse(error.responseText)
                    desc = e.description
                    alert(desc)
                    event.target.classList.remove('ajax-loading')
                    event.target.innerHTML = btnText
                },
                success: function (data) {
                    if (data.api === true) {
                        if (data.url) {
                            window.location.href = data.url
                        } else {
                            alert('Something went wrong. Please contact our customer support.')
                        }
                    } else {
                        alert(data.msg)
                    }
                    event.target.classList.remove('ajax-loading')
                    event.target.innerHTML = btnText
                },
            })
        })
}

document.addEventListener('DOMContentLoaded', () => {
    const btnCartPage = document.querySelector('#cartform .checkout-col .button')
    if (btnCartPage) {
        if (window['discountOnCartProApp']) {
            btnCartPage.classList.remove('loading')
        } else {
            setTimeout(() => {
                btnCartPage.classList.remove('loading')
            }, 1500)
        }
    }
})

/* ===== H-OPTIONS-UPGRADE v2 START (2026-06-12) ===== */
/* ============================================================
   Deconovo PDP Custom Options Upgrade JS · 2026-06-12
   - Upscales swatch image sources (50px-era URLs -> retina)
   - Sets --swatch-zoom-image for PC hover preview
   - Injects magnifier buttons + zoom modal (tap to view large,
     prev/next within group, "Select this option")
   - Size-guide images: click to zoom
   - Mobile sticky Subtotal + Add to Cart bar
   Runs only when .product-options exists (custom PDPs).
   Never modifies pricing / option-linking logic.
   ============================================================ */
;(function () {
  'use strict';

  function init() {
    if (!document.querySelector('.product-options')) return;

    var labels = collectSwatchLabels();
    upgradeImageSources(labels);
    injectZoomButtons(labels);
    buildModal();
    bindSizeGuideZoom();
    buildStickyBar();
  }

  /* ---------- helpers ---------- */

  function upsizeUrl(url, px) {
    if (!url) return url;
    var u = url.replace(/width=\d+/, 'width=' + px);
    u = u.replace(/_(\d+)x(\.(?:jpg|jpeg|png|webp|gif))/i, '_' + px + 'x$2');
    return u;
  }

  function extractBgUrl(el) {
    // Prefer the custom property (add-on options), fall back to computed bg
    var cs = getComputedStyle(el);
    var v = cs.getPropertyValue('--swatch-background-image').trim() || cs.backgroundImage;
    var m = v && v.match(/url\(["']?([^"')]+)["']?\)/);
    return m ? m[1] : null;
  }

  // TWOPAGES-style short card label: drop long explanatory parentheticals,
  // keep short qualifiers like "(Dark Gray)" and prices like "(+ $25)".
  function shortLabel(t) {
    return t.replace(/[（(]([^()（）]*)[)）]/g, function (m, inner) {
      if (/^\s*\+/.test(inner)) return m;        // keep price "(+ $25)"
      if (inner.length <= 22) return m;          // keep short qualifiers
      return '';                                 // drop long explanations
    }).replace(/\s{2,}/g, ' ').trim();
  }

  function collectSwatchLabels() {
    var out = [];
    document.querySelectorAll('.option-selector--swatch .color-swatch.opt-label').forEach(function (label) {
      var url = extractBgUrl(label);
      if (!url || url.indexOf('no-image') !== -1) return; // skip placeholder swatches
      var input = document.getElementById(label.getAttribute('for')) ||
                  label.previousElementSibling;
      var textEl = label.querySelector('.opt-label__text');
      var fullTitle = textEl ? textEl.textContent.trim() : (label.getAttribute('data-swatch') || '');
      // overlay strips on add-on cards show the shortened label; modal keeps full text
      if (textEl && label.closest('.product-options')) {
        textEl.textContent = shortLabel(fullTitle);
      }
      out.push({
        label: label,
        input: (input && input.classList && input.classList.contains('opt-btn')) ? input : null,
        url: url,
        title: fullTitle,
        group: label.closest('.option-selector--swatch')
      });
    });
    return out;
  }

  /* ---------- 1. image source upgrade + zoom var ---------- */

  function upgradeImageSources(items) {
    items.forEach(function (it) {
      var card = upsizeUrl(it.url, 400);
      var zoom = upsizeUrl(it.url, 800);
      // Add-on cards read --swatch-card-image; main color labels use inline bg
      it.label.style.setProperty('--swatch-card-image', 'url(' + card + ')');
      it.label.style.setProperty('--swatch-zoom-image', 'url(' + zoom + ')');
      if (it.label.closest('.product-options') === null) {
        // main fabric color swatch: swap inline background to sharper source
        it.label.style.backgroundImage = 'url(' + upsizeUrl(it.url, 200) + ')';
      }
      it.zoomUrl = zoom;
    });
  }

  /* ---------- 2. magnifier buttons ---------- */

  var ZOOM_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7" stroke="inherit"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

  function injectZoomButtons(items) {
    items.forEach(function (it, idx) {
      var btn = document.createElement('span');
      btn.className = 'h-swatch-zoom-btn';
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-label', 'View larger image');
      btn.innerHTML = ZOOM_SVG;
      btn.addEventListener('click', function (e) {
        // stop the label from toggling the radio underneath
        e.preventDefault();
        e.stopPropagation();
        openModal(items, idx);
      });
      it.label.appendChild(btn);
    });
  }

  /* ---------- 3. zoom modal ---------- */

  var modal, modalImg, modalTitle, modalPrev, modalNext, modalSelect;
  var modalItems = [], modalIdx = 0;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'h-zoom-modal';
    modal.innerHTML =
      '<div class="h-zoom-modal__panel">' +
      '  <button type="button" class="h-zoom-modal__close" aria-label="Close">&#10005;</button>' +
      '  <button type="button" class="h-zoom-modal__nav h-zoom-modal__nav--prev" aria-label="Previous">&#8249;</button>' +
      '  <img class="h-zoom-modal__img" alt="">' +
      '  <button type="button" class="h-zoom-modal__nav h-zoom-modal__nav--next" aria-label="Next">&#8250;</button>' +
      '  <div class="h-zoom-modal__title"></div>' +
      '  <button type="button" class="h-zoom-modal__select">Select this option</button>' +
      '</div>';
    document.body.appendChild(modal);

    modalImg = modal.querySelector('.h-zoom-modal__img');
    modalTitle = modal.querySelector('.h-zoom-modal__title');
    modalPrev = modal.querySelector('.h-zoom-modal__nav--prev');
    modalNext = modal.querySelector('.h-zoom-modal__nav--next');
    modalSelect = modal.querySelector('.h-zoom-modal__select');

    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    modal.querySelector('.h-zoom-modal__close').addEventListener('click', closeModal);
    modalPrev.addEventListener('click', function () { stepModal(-1); });
    modalNext.addEventListener('click', function () { stepModal(1); });
    modalSelect.addEventListener('click', function () {
      var it = modalItems[modalIdx];
      if (it && it.input && !it.input.checked) it.input.click();
      closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') stepModal(-1);
      if (e.key === 'ArrowRight') stepModal(1);
    });
  }

  function openModal(allItems, idx) {
    // restrict prev/next to the same option group
    var group = allItems[idx].group;
    modalItems = allItems.filter(function (it) { return it.group === group; });
    modalIdx = modalItems.indexOf(allItems[idx]);
    renderModal();
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function openModalSingle(src, title) {
    modalItems = [{ zoomUrl: src, title: title || '', input: null }];
    modalIdx = 0;
    renderModal();
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function stepModal(d) {
    var n = modalIdx + d;
    if (n < 0 || n >= modalItems.length) return;
    modalIdx = n;
    renderModal();
  }

  function renderModal() {
    var it = modalItems[modalIdx];
    modalImg.src = it.zoomUrl;
    modalTitle.textContent = it.title;
    modalPrev.disabled = modalIdx === 0;
    modalNext.disabled = modalIdx === modalItems.length - 1;
    var multi = modalItems.length > 1;
    modalPrev.style.display = multi ? '' : 'none';
    modalNext.style.display = multi ? '' : 'none';
    if (it.input) {
      modalSelect.style.display = '';
      var sel = it.input.checked;
      modalSelect.textContent = sel ? 'Selected ✓' : 'Select this option';
      modalSelect.classList.toggle('is-selected', sel);
    } else {
      modalSelect.style.display = 'none';
    }
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ---------- 4. size-guide image zoom ---------- */

  function bindSizeGuideZoom() {
    document.querySelectorAll('.product-main .rimage-wrapper img').forEach(function (img) {
      img.addEventListener('click', function (e) {
        e.preventDefault();
        var src = img.currentSrc || img.src;
        // request a bigger rendition from Shopify CDN if sized
        openModalSingle(upsizeUrl(src, 1200), img.alt || '');
      });
    });
  }

  /* ---------- 5. mobile sticky buy bar ---------- */

  function buildStickyBar() {
    var priceSrc = document.querySelector('#h_price_js .current-price');
    var atcBtn = document.querySelector('.quantity-submit-row__submit .validate-button');
    var buyRow = document.querySelector('.buy-buttons-row');
    if (!priceSrc || !atcBtn || !buyRow) return;

    var bar = document.createElement('div');
    bar.className = 'h-sticky-atc';
    bar.innerHTML =
      '<div class="h-sticky-atc__price">' +
      '  <span class="h-sticky-atc__label">Subtotal</span>' +
      '  <span class="h-sticky-atc__value"></span>' +
      '</div>' +
      '<button type="button" class="h-sticky-atc__btn">Add to Cart</button>';
    document.body.appendChild(bar);

    var valueEl = bar.querySelector('.h-sticky-atc__value');
    function syncPrice() { valueEl.textContent = priceSrc.textContent.trim() || '—'; }
    syncPrice();
    new MutationObserver(syncPrice).observe(priceSrc, { childList: true, subtree: true, characterData: true });

    bar.querySelector('.h-sticky-atc__btn').addEventListener('click', function () {
      atcBtn.click();
      // if validation failed, bring the message into view
      setTimeout(function () {
        var msg = document.querySelector('.validate-options-message');
        if (msg && msg.textContent.trim()) {
          msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 120);
    });

    // show bar only while the real buy area is off-screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(buyRow);
    } else {
      bar.classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ===== H-OPTIONS-UPGRADE v2 END ===== */
